import { Component, OnInit, Inject } from '@angular/core';
import { CompanyService } from 'src/app/services/http/business/company/company.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatSelect } from '@angular/material';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { TranslateService } from '@ngstack/translate';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { ICompany } from 'src/app/interfaces/company';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { MarketerService } from 'src/app/services/http/business/marketer/marketer.service';
import { CIDService } from 'src/app/services/common/cid.service';
import { ContractService } from 'src/app/services/http/business/contract/contract.service';
import { IError } from 'src/app/interfaces/error.interface';

@Component({
  selector: 'app-marketer-entry',
  templateUrl: './marketer-entry.component.html',
  styleUrls: ['./marketer-entry.component.css']
})
export class MarketerEntryComponent implements OnInit {

  param: any;
  errorList: IError[] = [];
  errObject: any;
  form: FormGroup;
  companyList: ICompany[];
  errors = new Array();
  completePercent = 0;
  personNotFound: boolean;
  personInfo: any;
  showUserSearch = false;


  constructor(
    private companyService: CompanyService,
    private marketerService: MarketerService,
    private fb: FormBuilder,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private cidService: CIDService,
    private contractService: ContractService,
    private dialogRef: MatDialogRef<MarketerEntryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.createMarketerForm();
    this.getCompanyList();
  }

  createMarketerForm() {
    this.form = this.fb.group({
      NationalCode: [this.data ? this.data.NationalCode : null, Validators.compose([Validators.required,Validators.pattern("^[0-9]*$"),
      Validators.minLength(10),
      Validators.maxLength(12)])],
      CompanyEncryptId: [this.data ? this.data.CompanyEncryptId : null, Validators.compose([Validators.required])],
      LimitationInMonth: [this.data ? this.data.LimitationInMonth : null, Validators.compose([Validators.required, Validators.min(1), Validators.max(1000)])]
      //PersonEncryptId: [null, Validators.compose([Validators.required])]
    });
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }
  setCid(e: MatSelect) {
    this.showUserSearch = true;
    this.cidService.setCID(e.value);
  }

  searchUser(form: any) {
    this.errors = new Array();
    this.contractService.getCompanyContractUser().subscribe(res => {
      var person = res.filter(r => r.NationalCode == form.NationalCode)[0]
      if (person) {
        this.personNotFound = false;
        this.personInfo = person;
      }
      else {
        this.personNotFound = true;
      }
    }, () => { });
    //this.accountService.getSimpleUserInfo(form.NationalCode).subscribe(
    //  res => {
    //    this.personInfo = res;
    //    console.log(res);
    //    //this.form.value.PersonEncryptId = res.
    //  },
    //  err => {
    //    this.errObject = this.errorService.getError(err);
    //    this.param = this.errorService.objectError(this.errObject);
    //    this.errors = this.errorService.returnError(err);
    //  }
    //);
  }

  submit(data: any) {
    this.errors = new Array();
    let model = {
      LimitationInMonth: data.LimitationInMonth,
      PersonEncryptId: this.data ? this.data.PersonEncryptId : this.personInfo.PersonEncryptId,
      CompanyEncryptId: data.CompanyEncryptId
    };
    this.marketerService.save(model).subscribe(
      () => {
        this.onNoClick();
        this.snackBar.OpenSnackBar(
          this.translate.get("success.addMarketer"),
          "ok",
          5000,
          SoundEnum.beep
        );
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );
  }

  onNoClick() {
    this.dialogRef.close();
  }

}
